class TranslationHelper {
    constructor(translationsDb) {
        // key value object
        this.translationsDb = translationsDb
    }
    t(data, customReplacements = {}, nbr = null) {
        if (data === undefined || data === null || nbr === 0) {
            return null
        }

        const replacements = {
            nbr: nbr,
            ...customReplacements
        }

        let key = data
        if (Array.isArray(data)) {
            const index = Math.max(0, Math.min(nbr, data.length) - 1)
            key = data[index]

            if (key === undefined) {
                return null
            }
        }

        const translatedString = this.translationsDb[key] || key

        if (typeof translatedString !== 'string') {
            return String(translatedString)
        }

        try {
            return translatedString.replace(/{([a-zA-Z0-9_]+)}/g, (match, placeholder) => {
                if (placeholder in replacements) {
                    return replacements[placeholder] ?? ''
                }

                return match
            })
        } catch (error) {
            console.error(`Translation error: ${error.message}`, { data, nbr, key })
            return translatedString
        }
    }

}
export default TranslationHelper